export const EXTENDED_PREFERENCES_FIELD_TYPES = {
	FREE_TEXT_FIELD: 1,
	DROPDOWN_FIELD: 2,
	MULTI_SELECT_DROPDOWN_FIELD: 3
}
